import moment from "moment";
import { verifyToken } from "../../../api/onboarding";
import { getToken } from "../../../Apimanager/Networking";
import { checkForUrlParams, isAndroidDevice, isNewApp } from "../../../helper/CommonFuncs";
import { store } from "../../../redux/store";
import { isCognitoAuth } from "../../../auth/region";
import { getRegionFromCookie, isDev } from "../../getRegions/regionActions";
import { getStsTokens } from "../../../auth/session";
import messagesData from "../component/shared/ErrorSuccessMessages.json";
import { PRESERVE_ALL_QUERY_PARAMS, WEBVIEW_QUERY_KEY, isWebViewQueryActive } from "./webviewQuery";

export {
   withPreservedQuery,
   getPreservedQueryString,
   WEBVIEW_QUERY_KEY,
   PRESERVE_ALL_QUERY_PARAMS,
   isWebViewQueryActive,
   appSupportsEURegion,
} from "./webviewQuery";

export const getSubtitleBasedOnStep = (step, isMfa, isFreemiumProvider = false, email) => {
   switch (step) {
      case 0:
         return "";
      case 1:
         return "";
      case 2:
         if (isMfa || !isFreemiumProvider) {
            return "We’ve sent your code to the phone number listed in your account";
         } else {
            return "We’ve sent your code to ";
         }
      default:
         return "";
   }
};
export const getMainTitle = (step, isSignup) => {
   switch (step) {
      case 0:
         return isSignup && step === 0 ? "Get started in seconds" : "Log In to Playback Pro";
      case 1:
         return "Enter Your Password";
      case 2:
         return "Verify Your Account ";

      default:
         return "";
   }
};

export const disableButton = (step, email, password, otp, fullName) => {
   const pathname = window.location.pathname;
   const isSignup = pathname.includes("sign-up");
   switch (step) {
      case 0:
         return !email?.trim() || (isSignup && !fullName);
      case 1:
         return password?.trim()?.length === 0;
      case 2:
         return otp?.trim()?.length === 0;

      default:
         return "";
   }
};

export const getUnderlineText = (step) => {
   switch (step) {
      case 0:
         return "Need help?";
      case 1:
         return "Forgot Password?";
      case 2:
         return "Need help?";
      default:
         return "";
   }
};

export const getButtonText = (step) => {
   switch (step) {
      case 0:
         return "Continue";
      case 1:
         return "Continue";
      case 2:
         return "Continue";
      default:
         return "";
   }
};

export const checkValidPassword = (password) => {
   let message = "";
   if (password.length < 8) {
      message = messagesData.messages[4]?.passwordWeak8Char;
   }
   // Check for at least one lowercase letter
   else if (!/[a-z]/.test(password)) {
      message = messagesData.messages[4]?.passwordWeak1LowerLetter;
   }
   // Check for at least one special character
   else if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      message = messagesData.messages[4]?.passwordWeak1SpecialChar;
   }
   // Check for at least one number
   else if (!/[0-9]/.test(password)) {
      message = messagesData.messages[4]?.passwordWeak1Num;
   }
   // Check for at least one uppercase letter
   else if (!/[A-Z]/.test(password)) {
      message = messagesData.messages[4]?.passwordWeak1UpperLetter;
   }

   return message;
};

// Truncate the string from the middle
export const truncateMiddle = (str, maxLength) => {
   if (!str || str.length <= maxLength) return str;
   const half = Math.floor(maxLength / 2);
   return str.slice(0, half) + "..." + str.slice(str.length - half);
};

// Get the max length based on screen width
export const getResponsiveMaxLength = (screenWidth) => {
   if (screenWidth < 890) return 25;
   if (screenWidth <= 1024) return 40;
   if (screenWidth <= 1150) return 55;
   if (screenWidth <= 1280) return 68;
   if (screenWidth <= 1340) return 85;
   if (screenWidth <= 1440) return 90;
   return 100;
};

export const buildCognitoDeepLinkUrl = (tokens = {}) => {
   const region = getRegionFromCookie();
   const params = new URLSearchParams();

   const accessToken = tokens.accessToken || tokens.cognitoAccessToken;
   const refreshToken = tokens.refreshToken || tokens.cognitoRefreshToken;
   const idToken = tokens.idToken || tokens.cognitoIdToken;

   if (accessToken) params.set("accessToken", accessToken);
   if (refreshToken) params.set("refreshToken", refreshToken);
   if (idToken) params.set("idToken", idToken);
   if (region) params.set("region", region);

   let uriIos = "com.playbackhealth.pro://";
   let uriAndroid = "com.playbackhealth.pro://";
   if (isDev) {
      uriIos = "com.playbackhealth.providers://";
      uriAndroid = "com.playbackhealth.providers://";
   }

   const query = params.toString();
   if (!query) return "";

   const scheme = isAndroidDevice() ? uriAndroid : uriIos;
   return `${scheme}?${query}`;
};

export const openApp = async () => {
   if (localStorage.getItem("isLoadedOnWebView") !== "true") {
      return;
   }

   if (isCognitoAuth()) {
      const token = await getToken();
      if (!token) return;
      const url = buildCognitoDeepLinkUrl(getStsTokens());
      if (url) window.location.href = url;
      return;
   }

   const token = await getToken();
   if (token) {
      try {
         const response = await verifyToken({ firebaseToken: token });
         if (response) {
            if (token) {
               let str = "?token=" + response.customToken;
               const region = getRegionFromCookie();
               if (region) {
                  str += "&region=" + region;
               }
               let uriIos = "com.playbackhealth.pro://";
               let uriAndroid = "com.playbackhealth.pro://";
               if (isDev) {
                  uriIos = "com.playbackhealth.providers://";
                  uriAndroid = "com.playbackhealth.providers://";
               }
               const finalURI = isAndroidDevice() ? uriAndroid + str : uriIos + str;
               window.location.href = finalURI;
            }
         }
      } catch (error) { }
   }
};
export const redirectUrl = () =>
   isAndroidDevice()
      ? "https://play.google.com/store/apps/details?id=com.playbackhealth.pro"
      : "https://apps.apple.com/in/app/playback-health-pro/id6479377243";

export const isWebView = () => {
   if (checkForUrlParams("webview", "true") && isNewApp) {
      localStorage.setItem("isLoadedOnWebView", "true");
      if (PRESERVE_ALL_QUERY_PARAMS && window.location.search) {
         localStorage.setItem(WEBVIEW_QUERY_KEY, window.location.search);
      }
   } else {
      localStorage.removeItem("isLoadedOnWebView");
      if (PRESERVE_ALL_QUERY_PARAMS) {
         localStorage.removeItem(WEBVIEW_QUERY_KEY);
      }
   }
};

export const openAppEpic = (customToken) => {
   if (isCognitoAuth()) {
      const url = buildCognitoDeepLinkUrl(customToken);
      if (url) window.location.href = url;
      return;
   }

   const region = getRegionFromCookie();
   let str = "?token=" + customToken;
   if (region) {
      str += "&region=" + region;
   }
   let uriIos = "com.playbackhealth.pro://";
   let uriAndroid = "com.playbackhealth.pro://";
   if (isDev) {
      uriIos = "com.playbackhealth.providers://";
      uriAndroid = "com.playbackhealth.providers://";
   }
   localStorage.removeItem("googleLoginShowAlert");
   const finalURI = isAndroidDevice() ? uriAndroid + str : uriIos + str;
   window.location.href = finalURI;
};

export const isLoadedOnWebView = () => {
   return localStorage.getItem("isLoadedOnWebView") === "true";
};

export const redirectSamlLogin = (providerId = "saml.northwell") => {
   let samlLoginUrl = "https://playbackprod.firebaseapp.com/sso-login-new.html";
   if (isDev) {
      samlLoginUrl = "https://playbackplatform.firebaseapp.com/sso-login-new.html";
   }
   samlLoginUrl += `?providerId=${providerId}`;
   window.location.replace(samlLoginUrl);
};

export const getAppUrl = () => {
   return window.location.origin + "/get";
};

export const isDevelopmentEnvironment = isDev;

export const sendDataDogLogsEngage = (customEvent = false, info = null) => {
   const patientId = window.location.pathname.split("/").find(find => find && !find.trim().includes("patient")) || "N/A"
   const userId = store.getState()?.auth?.loggedInProviderDetails?.id;
   const todayDate = moment().format("MM/DD/YYYY");
   let eventName = customEvent + "-" + userId + "-" + patientId + "-" + todayDate;
   let payload = {
      "browser-agent": navigator.userAgent,
      providerId: userId,
      patientId
   }
   if (info) {
      payload = { ...payload, info: info }
   }
   if (window.DD_RUM && userId) {
      window.DD_RUM.addAction(eventName, payload);
   }
};